import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { UserKpisInMinutes } from '@wilson/interfaces';
import { UserKpisDataSourceService } from '@wilson/shift-timeline/assignments-gantt-chart';
import { TimelineKpisState } from '@wilson/shift-timeline/state';
import { Observable } from 'rxjs';

@Injectable()
export class ShiftTimelineKpiDataSourceServiceService extends UserKpisDataSourceService {
  private store = inject(Store);

  override fetchingWeeklyKpiForUserIdsStream(): Observable<string[]> {
    return this.store.select(TimelineKpisState.fetchingWeeklyKpiForUserIds);
  }

  override fetchingMonthlyKpiForUserIdsStream(): Observable<string[]> {
    return this.store.select(TimelineKpisState.fetchingMonthlyKpiForUserIds);
  }

  override updatingKpiUserIdsStream(): Observable<string[]> {
    return this.store.select(TimelineKpisState.updatingKpiUserIds);
  }

  override userKpisWeekStream(
    userId: string,
  ): Observable<UserKpisInMinutes | undefined> {
    return this.store.select(TimelineKpisState.userKpisForWeekByUserId(userId));
  }

  override userKpisMonthStream(
    userId: string,
  ): Observable<UserKpisInMinutes | undefined> {
    return this.store.select(
      TimelineKpisState.userKpisForMonthByUserId(userId),
    );
  }
}
